import { render, staticRenderFns } from "./FabricFilter.vue?vue&type=template&id=b512a812&"
import script from "./FabricFilter.vue?vue&type=script&lang=js&"
export * from "./FabricFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports